import { createContext, useContext } from "react";
import { Dictionary } from "aphrodite.react/Helpers";
import { ConfigurationGetResponse, LanguageGetResponse, SessionGetResponse } from "AdminApi/AdminApi";

interface AppContextState {
    resource: (key: string, variables?: Dictionary<string | number>) => string;
    session: SessionGetResponse | null | undefined;
    refreshSession: () => Promise<void>;
    languages: LanguageGetResponse[] | null;
    refreshLanguages: () => void;
    configuration: ConfigurationGetResponse | null;
    isBusy: boolean;
    busyWhile: <T, >(task: () => T) => Promise<T>;
}

export const AppContext = createContext<AppContextState>({
    resource: () => {
        return "No resource finder has been implemented";
    },
    session: null,
    refreshSession: () => Promise.reject(),
    languages: null,
    refreshLanguages: () => { },
    configuration: null,
    isBusy: false,
    busyWhile: null!
});

export function useApp() {
    return useContext(AppContext);
}
